/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import React from "react";
import {
  ErrorStateComponent,
  ErrorStateIconType,
  IErrorStateComponentProps,
} from "@cseo/controls";

const payload: IErrorStateComponentProps = {
  headingText: "Doh! It's a 404",
  descriptionText:
    "Sorry, we couldn't find the page you are looking for. Please click on the request link you received in your email and try again. If the issue persists,",
  descriptionLinkText: "submit a support request.",
  descriptionLinkUrl: `${process.env.REACT_APP_CAREERS_PORTAL_SUPPORT_URI}`,
  iconType: ErrorStateIconType.OrangeCapAndCat,
  styles: {
    root: {
      paddingTop: 10,
      paddingBottom: 10,
    },
  },
};

export const PageErrorBody: React.FC = () => {
  return <ErrorStateComponent {...payload} />;
};
